// src/contexts/AuthContext.js

import React, { createContext, useState, useEffect } from "react";
import AuthServices from "../services/Auth.services";
import { useNavigate } from "react-router-dom";
import axios from "axios";
export const AuthContext = createContext(null);

export const AuthProvider = ({ children }) => {
  const savedAccess =
    localStorage.getItem("accessToken") ||
    sessionStorage.getItem("accessToken");
  const savedRefresh =
    localStorage.getItem("refreshToken") ||
    sessionStorage.getItem("refreshToken");
  const savedUser =
    localStorage.getItem("user") || sessionStorage.getItem("user");
  const [user, setUser] = useState(JSON.parse(savedUser) || null);
  const [isLogged, setIsLogged] = useState(
    localStorage.getItem("isLogged") || sessionStorage.getItem("isLogged")
      ? true
      : false,
  );
  const [isLoading, setIsLoading] = useState(false);
  const [isAdmin, setIsAdmin] = useState(false);
  const [accessToken, setAccessToken] = useState(null);
  const [refreshToken, setRefreshToken] = useState(null);

  const navigate = useNavigate();

  useEffect(() => {
    if (savedAccess && savedRefresh && savedUser) {
      setAccessToken(savedAccess);
      setRefreshToken(savedRefresh);
      setUser(JSON.parse(savedUser));
      setIsLogged(true);
    }
  }, []);
  // Création d'un axios instance globale
  const api = axios.create({
    baseURL: process.env.REACT_APP_HOST_API || "http://localhost:4000/api/v1",
  });

  // Intercepteur pour ajouter le token à chaque requête
  api.interceptors.request.use((config) => {
    const access =
      localStorage.getItem("accessToken") ||
      sessionStorage.getItem("accessToken");
    if (access) config.headers["Authorization"] = `Bearer ${access}`;
    return config;
  });

  // Intercepteur pour gérer le refresh token
  api.interceptors.response.use(
    (response) => response,

    async (error) => {
      const originalRequest = error.config;

      const refreshToken =
        localStorage.getItem("refreshToken") ||
        sessionStorage.getItem("refreshToken");
      const user =
        JSON.parse(localStorage.getItem("user")) ||
        JSON.parse(sessionStorage.getItem("user"));

      if (
        error.response?.status === 401 &&
        !originalRequest._retry &&
        refreshToken
      ) {
        originalRequest._retry = true;
        try {
          const res = await axios.post(
            `${process.env.REACT_APP_HOST_API || "http://localhost:4000/api/v1/"}auth/refresh-token`,
            { refresh: refreshToken, userId: user?._id },
          );

          localStorage.setItem("accessToken", res.data.access);
          sessionStorage.setItem("accessToken", res.data.access);

          originalRequest.headers["Authorization"] =
            `Bearer ${res.data.access}`;

          return api(originalRequest);
        } catch (err) {
          console.log("Refresh failed");
          console.log(err);
          logout();
          originalRequest._retry = false;
          return Promise.reject(err);
        }
      }

      return Promise.reject(error);
    },
  );

  const login = (credentials, setAlert) => {
    setIsLoading(true);
    AuthServices.login(credentials)
      .then((res) => {
        // console.log("res.data.user.role:", res.data);
        setIsLoading(false);
        if (res.data?.access && res.data?.refresh && res.data?.user) {
          setUser(res.data.user);
          setAccessToken(res.data.access);
          setRefreshToken(res.data.refresh);
          const resterConnecter = sessionStorage.getItem("resteConnecter");
          if (resterConnecter == "false") {
            sessionStorage.removeItem("resteConnecter");
            // Sauvegarde dans le localStorage
            sessionStorage.setItem("accessToken", res.data.access);
            sessionStorage.setItem("refreshToken", res.data.refresh);
            sessionStorage.setItem("user", JSON.stringify(res.data.user));
            sessionStorage.setItem("isLogged", true);
          } else {
            // Sauvegarde dans le localStorage
            sessionStorage.removeItem("resteConnecter");
            localStorage.setItem("accessToken", res.data.access);
            localStorage.setItem("refreshToken", res.data.refresh);
            localStorage.setItem("user", JSON.stringify(res.data.user));
            localStorage.setItem("isLogged", true);
          }
          setIsLogged(true);

          if (res.data.user.role == 1) {
            setIsAdmin(true);
            navigate("/admin/dashboard");
          } else {
            setIsAdmin(false);
            const navigation = localStorage.getItem("navigation");
            if (navigation == "login") {
              localStorage.removeItem("navigation");
              navigate("/");
            } else {
              localStorage.removeItem("navigation");
              navigate("/article/creation");
            }
          }
          setIsLoading(false);
          return;
        }
        navigate(
          "/connexion/validation/" + res.data.userId + "/" + credentials.email,
        );
      })
      .catch((err) => {
        setIsLoading(false);
        setAlert({
          message:
            err.response?.data?.message ||
            "Erreur de connexion. Veuillez réessayer.",
          type: "danger",
        });
        console.error("Erreur de connexion :", err);
      });
  };

  const logout = () => {
    const deviceId = localStorage.getItem("deviceId");
    AuthServices.logout({ userId: user?._id })
      .then(() => {
        setAccessToken(null);
        setRefreshToken(null);
        setIsLogged(false);
        setIsLoading(false);
        // Supprime tous les items du localStorage
        localStorage.clear();
        sessionStorage.clear();
        if (deviceId) localStorage.setItem("deviceId", deviceId);
        navigate("/");
      })
      .catch((err) => {
        setAccessToken(null);
        setRefreshToken(null);
        setIsLogged(false);
        setIsLoading(false);
        // Supprime tous les items du localStorage
        localStorage.clear();
        sessionStorage.clear();
        if (deviceId) localStorage.setItem("deviceId", deviceId);
        navigate("/");
        console.error("Erreur de déconnexion :", err);
      });
  };

  const verifyOtp = async (data, setAlert) => {
    return await AuthServices.verifyOtp(data)
      .then((res) => {
        // console.log(res);
        setUser(res.data.user);
        setAccessToken(res.data.access);
        setRefreshToken(res.data.refresh);
        const resterConnecter = sessionStorage.getItem("resteConnecter");
        if (resterConnecter == "false") {
          sessionStorage.removeItem("resteConnecter");
          // Sauvegarde dans le localStorage
          sessionStorage.setItem("accessToken", res.data.access);
          sessionStorage.setItem("refreshToken", res.data.refresh);
          sessionStorage.setItem("user", JSON.stringify(res.data.user));
          sessionStorage.setItem("isLogged", true);
        } else {
          // Sauvegarde dans le localStorage
          sessionStorage.removeItem("resteConnecter");
          localStorage.setItem("accessToken", res.data.access);
          localStorage.setItem("refreshToken", res.data.refresh);
          localStorage.setItem("user", JSON.stringify(res.data.user));
          localStorage.setItem("isLogged", true);
        }

        setIsLogged(true);
        if (res.data.user.role == 1) {
          setIsAdmin(true);
          navigate("/admin/dashboard");
        } else {
          setIsAdmin(false);
          const navigation = localStorage.getItem("navigation");
          if (navigation == "login") {
            localStorage.removeItem("navigation");
            navigate("/");
          } else {
            localStorage.removeItem("navigation");
            navigate("/article/creation");
          }
        }
        setIsLoading(false);
      })
      .catch((err) => {
        setIsLoading(false);
        setAlert({
          message:
            "Erreur de vérification OTP (invalide ou expiré). Veuillez vous reconnecter dans un instant.",
          type: "danger",
        });
        console.error("Erreur de vérification OTP :", err);
      });
  };

  const verifyCaptchaV3 = async (action) => {
    return await AuthServices.verifyCaptchaV3(action);
  };

  return (
    <AuthContext.Provider
      value={{
        user,
        isLogged,
        isLoading,
        isAdmin,
        login,
        logout,
        setIsLoading,
        verifyOtp,
        verifyCaptchaV3,
        accessToken,
        refreshToken,
        api,
        setIsLogged,
        setUser,
        setAccessToken,
        setRefreshToken,
        setIsAdmin,
      }}
    >
      {children}
    </AuthContext.Provider>
  );
};
